import { Link } from "react-router-dom";
import Block from "../components/Block";
import Seam from "../components/Seam";
import Seo from "../components/Seo";

export default function OurIp() {
  return (
    <>
      <Seo
        title="Our IP & products"
        description="Products and government systems owned and operated by Gapsmiths Consulting LLP."
      />
      <section className="wrap page-head">
        <h1>Our IP &amp; products</h1>
        <p className="lede">Some of what we build, we keep.</p>
      </section>

      <Seam />

      <Block marker="Why we build our own">
        <p>
          Not everything we make is for someone else. Some of it started as a business
          idea, some as a personal itch, and some because we saw a problem up close
          and decided to solve it properly. We own all of it, and we run it the way
          we'd want a client's product run.
        </p>
        <p>It's also the most honest reference we can offer. When we say we ship, you can go and check.</p>
      </Block>

      <Seam />

      <Block marker="Everything we own" bodyClassName="wide">
        <div className="group">
          <h3>Products</h3>
          <div className="item">
            <h4>Prism Books</h4>
            <div>
              <p>
                Finance intelligence for businesses that run on Tally. Photograph a
                bill on WhatsApp and it's in your books. Ask a question about your
                numbers in plain English and get an answer. Consolidate several
                companies and produce Schedule III statements without rebuilding
                spreadsheets.
              </p>
              <Link className="link" to="/prism">Read more about Prism Books</Link>
            </div>
          </div>
          <div className="item">
            <h4>SkillNest</h4>
            <div>
              <p>A place for parents to keep their kids' sports training videos and share them with coaches.</p>
              <a className="link" href="https://getskillnest.com" target="_blank" rel="noopener noreferrer">getskillnest.com</a>
            </div>
          </div>
          <div className="item">
            <h4>The Riding Post</h4>
            <div>
              <p>Media, marketplace, and sponsorship for equestrian sport in India.</p>
              <a className="link" href="https://theridingpost.com" target="_blank" rel="noopener noreferrer">theridingpost.com</a>
            </div>
          </div>
        </div>

        <div className="group">
          <h3>Government systems</h3>
          <div className="item">
            <h4>SAMADHAN</h4>
            <div>
              <p>
                Station Application Management, Acknowledgement, Disposal &amp;
                Analytics. Every application that reaches a station is logged,
                acknowledged, tracked to a decision, and reported on, so nothing sits
                in a pile.
              </p>
            </div>
          </div>
          <div className="item">
            <h4>ACB Application Processing</h4>
            <div>
              <p>Takes applications from arrival to outcome, with every step recorded and nothing lost between desks.</p>
            </div>
          </div>
        </div>
      </Block>
    </>
  );
}
